export default "__VITE_PUBLIC_ASSET__96967b41__"